var _g, _defs;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgSidebarPortfolios(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_0_112)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.75 8.0001C2.75 9.2421 5.1 10.2501 8 10.2501C10.9 10.2501 13.25 9.2421 13.25 8.0001M8 7.3501C10.9 7.3501 13.15 6.3431 13.15 5.1001C13.15 3.8571 10.9 2.8501 8 2.8501C5.1 2.8501 2.85 3.8571 2.85 5.1001C2.85 6.3431 5.1 7.3501 8 7.3501Z",
    stroke: "white",
    strokeWidth: 1.7,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.75 11C2.75 12.242 5.1 13.25 8 13.25C10.9 13.25 13.25 12.242 13.25 11",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.75 4.25C3.164 4.25 3.7 4.586 3.7 5V11C3.7 11.057 3.696 11.15 3.696 11.15C3.872 11.328 4.163 11.52 4.583 11.7C5.419 12.058 6.626 12.3 8 12.3C9.374 12.3 10.581 12.058 11.417 11.7C11.837 11.52 12.128 11.328 12.304 11.15C12.304 11.15 12.3 11.057 12.3 11V5C12.3 4.586 12.836 4.25 13.25 4.25C13.4489 4.25 13.6397 4.32902 13.7803 4.46967C13.921 4.61032 14 4.80109 14 5V11C14 11.564 13.73 12.039 13.371 12.402C13.016 12.762 12.539 13.052 12.008 13.28C10.945 13.736 9.528 14 8 14C6.473 14 5.055 13.736 3.992 13.28C3.462 13.053 2.984 12.762 2.628 12.402C2.27 12.04 2 11.564 2 11V5C2 4.80109 2.07902 4.61032 2.21967 4.46967C2.36032 4.32902 2.55109 4.25 2.75 4.25Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_0_112"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSidebarPortfolios);
export default __webpack_public_path__ + "static/media/sidebar-portfolios.eae51e51f044a4b5480ba3db412f5f28.svg";
export { ForwardRef as ReactComponent };